'use client';

import Link from "next/link";


import { useNavigate } from "../../hooks/useNavigate";
import React, { useState, useEffect, useRef } from "react";

import Image from "../../components/Image.jsx";
import { StyledButton } from "../../components/Buttons/StyledButton.jsx";
import { GoArrowUpRight } from "react-icons/go";
import AlternateImageDetails from "../../components/AlternateImageDetails.jsx";

const careerIMG1 = "/assets/career/careerimg_11zon (1).jpg";
const careerIMG2 = "/assets/career/careerimg1_11zon.jpg";
const careerIMG3 = "/assets/career/careerimg5_11zon.jpg";
const careerIMG4 = "/assets/career/careerimg3_11zon.jpg";
const careerIMG5 = "/assets/career/careerimg7_11zon.jpg";
const careerIMG6 = "/assets/career/careerimg6_11zon.jpg";
const careersContent = [
  {
    title: "Why Join Us?",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>• Work on cutting-edge technologies and impactful projects</li>
        <li>• Thrive in a culture of innovation, growth, and collaboration</li>
        <li>• Competitive compensation with performance-based rewards</li>
        <li>• Be part of a team that values creativity and excellence</li>
      </ul>
    ),
    image: careerIMG5,
  },
  {
    title: "Perks & Benefits",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>• Flexible work options, including remote opportunities</li>
        <li>• Health and wellness programs for a balanced lifestyle</li>
        <li>• Learning stipends and professional development support</li>
        <li>• Fun team outings, hackathons, and networking events</li>
      </ul>
    ),
    image: careerIMG2,
  },
  {
    title: "Learning & Growth",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>• Mentorship programs to accelerate your career</li>
        <li>• Hands-on experience with real-world projects</li>
        <li>• Access to certifications, courses, and training</li>
        <li>• Encouragement for research, innovation, and leadership</li>
      </ul>
    ),
    image: careerIMG6,
  },
  {
    title: "Internships & Early Careers",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>
          • Gain industry experience through structured internship programs
        </li>
        <li>• Work with experts and contribute to live projects</li>
        <li>• Fast-track your career with hands-on mentorship</li>
        <li>• Opportunity to transition into a full-time role</li>
      </ul>
    ),
    image: careerIMG4,
  },
];

export default function Careers() {
  const navigate = useNavigate();
  const [visibleSections, setVisibleSections] = useState({});

  return (
    <div className=" text-white flex flex-col ">
      <div className="mt-20 w-full flex items-center justify-center bg-cover bg-center relative">
        <div className="absolute inset-0 bg-opacity-70"></div>

        <div className="max-w-screen-xl mx-auto px-4 flex flex-col lg:flex-row items-center justify-between relative z-10 py-9">
          {/* Left Section - Text */}
          <div className="w-full lg:w-1/2 text-center lg:text-left px-8">
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-semibold">
              Break Limits.
              <br /> Build the Future.
            </h1>
            <p className="font-medium text-lg mt-6 sm:text-xl lg:text-2xl text-color-2">
              Step into a place where ideas turn into impact. Innovate boldly,
              grow fearlessly, and lead the future.
            </p>

            {/* Buttons */}
            <div className="mt-8 mb-3 flex justify-center lg:justify-start space-x-4">
              <StyledButton
                text="Explore Careers"
                onClick={() => {
                  navigate("#explore");
                }}
              />
            </div>
          </div>

          {/* Right Section - Image */}
          <div className="hidden md:flex w-full md:w-3/4 lg:w-1/2 justify-center">
            <Image
              src={careerIMG1}
              alt="Team Working"
              className="w-full max-w-lg rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto py-16 ">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold mb-2 text-center">
          Life At Centera Tech
        </h2>

        <AlternateImageDetails sections={careersContent} />

        <h2
          id="explore"
          className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-center pt-16"
        >
          Opportunities To Grow
        </h2>
        <div id="explore" className="max-w-5xl mx-auto px-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-screen-2xl mx-auto px-4 md:px-10 2xl:px-16 mt-10">
            {[
              {
                title: "Elevate Your Career",
                description:
                  "Join a team where innovation meets impact. Discover career opportunities that empower you to shape the future of technology.",
                image: careerIMG5,
                path: "/careers/jobs",
                buttonText: "View Job Openings",
              },
              {
                title: "Launch Your Future",
                description:
                  "Gain hands-on experience, collaborate with industry experts, and fast-track your career with our immersive internships.",
                image: careerIMG6,
                path: "/careers/internship",
                buttonText: "Apply For Internship",
              },
            ].map((card) => (
              <Description
                title={card.title}
                text={card.description}
                buttonText={card.buttonText}
                src={card.image}
                link={card.path}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const Description = ({
  title = "Title",
  text = "Subtitle",
  buttonText,
  src,
  link,
}) => (
  <Link
    href={link}
    className={`relative h-full w-full p-px rounded-xl overflow-hidden group transition-opacity duration-500`}
  >
    <div className="absolute inset-0 rounded-xl bg-[linear-gradient(155deg,var(--accent-light),#555_60%)] transition-transform duration-700 group-hover:rotate-180 blur-3xl scale-150"></div>
    <div
      className={`relative h-full flex flex-col flex-shrink-0 items-start justify-center gap-8 p-4 py-3 md:py-6 md:p-8 pb-24 md:pb-24 rounded-xl bg-color-98 `}
    >
      <div
        className={`flex flex-col items-start gap-4 self-stretch transition-all duration-300 z-10 pr-5`}
      >
        <div className="text-color-1 text-2xl lg:text-4xl font-semibold leading-[normal]">
          {title}
        </div>
        <div className="text-color-2 text-ellipsis">{text}</div>
      </div>
      <div className="absolute bottom-5 right-5 z-10 flex items-center gap-3 group/nested transition-all ">
        <p className="text-lg group-hover/nested:text-[--accent-light] transition-all duration-500">
          {buttonText}
        </p>
        <div
          aria-label={`Checkout ${title}`}
          className="scale-90 h-12 w-12 rounded-full flex justify-center items-center overflow-hidden cursor-pointer relative transition-all duration-500 border group-hover/nested:border-[--accent-light]"
        >
          <span className="sr-only">{title}</span>
          <div className="absolute inset-0 bg-[linear-gradient(180deg,_#fff,_#fff)] opacity-100 group-hover:opacity-0 transition-opacity duration-500"></div>
          <div className=" w-2 h-2 absolute -left-1 -bottom-1 group-hover:left-12 group-hover:bottom-9 -translate-x-1/2 translate-y-1/2 bg-color-100 group-hover:bg-color-1 rounded-full transition-all duration-700"></div>
          <span className="relative ">
            <GoArrowUpRight className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 transition-all duration-500 text-color-100 group-hover:text-color-1 group-hover/nested:text-[--accent-light] group-hover/nested:opacity-0 text-2xl group-hover:text-3xl font-bold " />
            <GoArrowUpRight className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 transition-all duration-500 text-color-100 group-hover:text-[--accent-light] opacity-0 group-hover/nested:opacity-100 text-2xl group-hover:text-3xl font-bold " />
          </span>
        </div>
      </div>
      <div className="absolute inset-0 object-cover h-full opacity-20 group-hover:opacity-10 group-hover:scale-125 origin-top-left transition-all duration-700 group-hover:blur-md">
        <Image src={src} alt={title} className="h-full" />
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(-45deg,#0000,#000a,#0000)] rounded-xl"></div>
      <div className="absolute top-0 -right-20 -rotate-45 w-[300px] h-[100px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-light))] blur-3xl opacity-10 z-10"></div>
    </div>
  </Link>
);
